import { useEffect, useState } from "react";
import { ASSET_ENDPOINT, ENCRYPTED_KEY, fetchData, PAGE_CONTENT } from "../../components/Service"
import AboutAuthor from "./partials/AboutAuthor";
import QuestionSolution from "../../components/QuestionSolution"
import DragAndFill from "../Exam/partials/QuestionType/DragAndFill";
import { now } from "lodash";
import { Context } from '../../components/Context';
import { useContext } from "react";
import { encodedText, noImageHandle, showAlertMsg } from "../../components/CommonMethod";
import { Link } from "react-router-dom";
import SliderTestimonials from "./partials/SliderTestimonials";
import SignUpModal from "./partials/SignUpModal";
import LazyLoadVideo from "../../components/LazyLoadVideo";

const NewHome = () => {
    window.document.title = "Home";

    const [homeContent, setHomeContent] = useState('')
    const [progressData, setProgressData] = useState({ index: 0, value: '', correctText: ['Well Done!'], incorrectText: ['Not quite..'] })
    const [aboutContent, setAboutContent] = useState('')
    const [question, setQuestion] = useState('')
    const [refresh, setRefresh] = useState(now)
    const [context] = useContext(Context)

    useEffect(() => {
        let block_user = localStorage.getItem('block_user')
        if (block_user) {
            localStorage.removeItem('block_user')
            showAlertMsg(JSON.parse(block_user))
        }
    }, [])

    useEffect(() => {
        fetchData(`${PAGE_CONTENT}?type=home-content`, 'GET', '', false, false, (res) => {
            if (res.records) {
                setHomeContent(JSON.parse(res.records))
                let question = JSON.parse(res.records).question
                if (question) setQuestion(question)
            }
        });

        fetchData(`${PAGE_CONTENT}?type=workbook-content`, 'GET', '', false, false, (res) => {
            if (res.records) {
                let progressText = JSON.parse(res.records);
                setProgressData({ correctText: progressText.correct_answer, incorrectText: progressText.incorrect_answer, index: 1, value: false })
            }
        });

        fetchData(`${PAGE_CONTENT}?type=about-content`, 'GET', '', false, false, (res) => {
            if (res.records) {
                setAboutContent(JSON.parse(res.records))
            }
        });
    }, [refresh])

    useEffect(() => {
        setQuestion('')
        setRefresh(now)
    }, [context])

    const tryAgain = () => {
        setQuestion('')
        setRefresh(now)
    }

    return (
        <>
            <section className="home-section1 bg-grey" id="padding-top">
                <img src="images/vector/shape1.svg" className="homebg-cover" alt="shape" />
                <div className="container container-1180 position-relative">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <h1 className="display-4 fw-bold mb-3">Boost Your Chemistry Results</h1>
                                <p className="h3 fw-normal mb-0"> The complete step-by-step guide for students </p>
                            </div>
                        </div>
                    </div>
                    <div className="row  align-items-center mt-5">
                        <div className="col-md-6 mb-5 mb-md-0 position-relative" style={{ zIndex: '91' }}>
                            <div class="ratio ratio-16x9 rounded-3 overflow-hidden">
                                {homeContent.featured_file_type === 'image' ? <img onError={noImageHandle} src={ASSET_ENDPOINT + homeContent.featured_video} alt="hero" /> : <video src={`${ASSET_ENDPOINT + homeContent.featured_video}`} autoPlay muted loop controls></video>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="home-sec-content d-flex align-items-start justify-content-center">
                                <svg className="icon mmwh-35 sm-mmwh-28 text-blue">
                                    <use href="#icon_subtract"></use>
                                </svg>
                                <div className="px-3 pe-lg-5">
                                    <h2 className="fw-bold mb-3">Build Skills, Boost <br /> Confidence</h2>
                                    <h4 className="fw-medium mb-4">Get access to the interactive study guide</h4>
                                    <div className="d-flex manage_sign_guest_btn gap-3">
                                        {context?.auth ? <>
                                            {context.auth.user_type === '2' ? <>
                                                <Link to={context?.auth?.group_details ? '/my-workbooks' : `/shop-details/${encodedText({ id: 'all' }, ENCRYPTED_KEY)}`} className="btn btn-theme-primary white-space btn-lg w-100">{context?.auth?.group_details ? 'My Workbooks' : 'Try now for free!'}</Link>
                                            </> : <Link to={'/cms'} className="btn btn-theme-primary white-space btn-lg w-100">Dashboard</Link>}
                                        </> : <Link to="#signUpModalForm" data-bs-toggle="modal" className="btn btn-theme-primary white-space btn-lg w-100">Try now for free!</Link>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <QuestionModel homeContent={homeContent} workbookContent={workbookContent} /> */}
            <section className="home-section2 bg-white pb-5" id="respon-sec">
                <div className="container container-1180 position-relative pb-5">
                    <div className="row g-4">
                        <div className="col-xl-10 offset-xl-1 text-center text-md-start">
                            <div className="d-flex align-items-start nml-mob-50">
                                <svg className="icon mmwh-35 d-none d-md-block sm-mmwh-28 text-orange">
                                    <use href="#icon_subtract"></use>
                                </svg>
                                <div className="px-3 maxw-800  mb-5 ">
                                    <h2 className="h1 fw-bold pe-0">We reinforce what you learn at school and allow you to thrive</h2>
                                    <p className="h4 fw-normal">Join hundreds of students who have started their journey of academic success.</p>
                                </div>
                            </div>
                            <div className="reinforce-items">
                                <div className="reinforce-item">
                                    <div className="row g-x-5 align-items-center">
                                        <div className="col-md-6 px-4 px-md-3 mb-4 mb-md-0">
                                            <LazyLoadVideo className="ratio ratio-4x3" src="/images/home/To the point video.mov" poster="/images/home/SPV.png" />
                                        </div>
                                        <div className="col-md-6">
                                            <div class="d-flex align-items-start justify-content-center">
                                                <svg className="icon mmwh-35 d-none d-md-block  sm-mmwh-28 text-sky">
                                                    <use href="#icon_subtract"></use>
                                                </svg>
                                                <div class="px-3">
                                                    <h3 class="fw-bold mb-3">Short, to the point videos</h3>
                                                    <p class="h5 fw-normal">Allowing you to learn the key concepts of chemistry so you can answer even
                                                        the hardest questions with confidence.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="reinforce-item">
                                    <div className="row flex-column-reverse flex-md-row g-x-5 align-items-center">
                                        <div className="col-md-6">
                                            <div class="d-flex align-items-start justify-content-center">
                                                <svg className="icon mmwh-35 d-none d-md-block  sm-mmwh-28 text-blue">
                                                    <use href="#icon_subtract"></use>
                                                </svg>
                                                <div class="px-3">
                                                    <h3 class="fw-bold mb-3">Variety of question styles for optimal learning</h3>
                                                    <p class="h5 fw-normal">Data shows that answering questions in different formats helps learning stick.</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6 px-4 px-md-3 mb-4 mb-md-0">
                                            <LazyLoadVideo className="ratio ratio-4x3" src="/images/home/Different Features.mp4" poster="/images/home/DF.png" />
                                            {/* <div className="relative ">
                                                {question &&
                                                    <DragAndFill
                                                        serialNo={1}
                                                        mode={'practice'}
                                                        question={question}
                                                        progressData={progressData}
                                                        setActiveQuestion={() => { }}
                                                        setPrevAnswerDetails={() => { }}
                                                        setPrevQuestionDetails={() => { }}
                                                        saveAnswer={() => { }}
                                                        setProgress={() => { }}
                                                        tryAgain={tryAgain}
                                                    />
                                                }
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="reinforce-item">
                                    <div className="row g-x-5 align-items-center">
                                        <div className="col-md-6 px-4 px-md-3 mb-4 mb-md-0">
                                            <LazyLoadVideo className="ratio ratio-4x3" src="/images/home/Exam Mode.mp4" poster="/images/home/EM.png" />
                                        </div>
                                        <div className="col-md-6">
                                            <div class="d-flex align-items-start justify-content-center">
                                                <svg className="icon mmwh-35 d-none d-md-block sm-mmwh-28 text-orange">
                                                    <use href="#icon_subtract"></use>
                                                </svg>
                                                <div class="px-3">
                                                    <h3 class="fw-bold mb-3">Timed chemistry exams</h3>
                                                    <p class="h5 fw-normal">Practice real life situations with our inbuilt timed chemistry exams, so you
                                                        can walk into your next exam prepared.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <SliderTestimonials page="home" />
            {/* <AboutAuthor aboutContent={aboutContent} /> */}
            <section className="home-section7 m-0">
                {/* <img src="images/vector/shape4.svg" className="homebg-cover" alt="shape" /> */}
                <div className="container position-relative container-1040">
                    <div className="row">
                        <div className="col-lg-10 col-xl-10 mx-auto">
                            <div className="d-flex text-center align-items-start justify-content-center">
                                <svg className="icon d-none d-md-block mmwh-35 sm-mmwh-28 text-green">
                                    <use href="#icon_subtract"></use>
                                </svg>
                                <div className="px-md-3  mb-3">
                                    <div>
                                        <h2 className="fw-bold">No longer worry if the way you learn is stopping you, we cater for all types of learners</h2>
                                        <p class="h4 fw-normal w-75 mx-auto">With a fully custom platform designed for students to go at their own pace</p>
                                    </div>
                                    <div className="d-flex px-sm-5 mx-sm-5 mt-4 justify-content-center">
                                        {context?.auth ? <>
                                            <Link to={`/shop-details/${encodedText({ id: 'all' }, ENCRYPTED_KEY)}`} className="btn btn-theme-success text-break  btn-lg w-100 mt-2">Get access to the interactive study guide now
                                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                                                </svg>
                                            </Link>
                                        </> : <>
                                            <Link to="#signUpModalForm" data-bs-toggle="modal" className="btn btn-theme-success text-break  btn-lg w-100 mt-2">Get access to the interactive study guide now
                                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-right-short" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8" />
                                                </svg>
                                            </Link>
                                        </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <QuestionSolution image={homeContent && homeContent.questions && homeContent.questions.solution_image} />
            {/* <FixedPopup /> */}
            <SignUpModal />
        </>
    )
}

export default NewHome